import React, { useEffect, useRef } from 'react';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import logo from 'assets/Overwatch_App_Logo_By_RescAlert_TM.png';
import axios from 'axios';

let timeoutID;

const GoogleSignIn = ({ callback, cancel }) => {
  const login = useGoogleLogin({
    onSuccess: async (response) => {
      console.log('onSuccess:', response);
      const userInfo = await axios
        .get('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${response.access_token}` },
        })
        .then((res) => res.data);

      if (!response.access_token) cancel();

      const providerData = {
        access_token: response.access_token,
        ...userInfo,
      };

      callback(providerData);

      mutex.current = false;
    },
    onError: (response) => {
      console.log('onError:', response);
    },
    onNonOAuthError: (response) => {
      console.log('onNonOAuthError:', response);
    },
  });

  const mutex = useRef();

  useEffect(() => {
    (async () => {
      if (mutex.current) return;
      mutex.current = true;
      login();
    })();
  }, []);

  return (
    <div>
      <div>Login via Google...</div>
      <button onClick={cancel}>Cancel</button>
    </div>
  );
};

export default GoogleSignIn;
